/**
 * Which auto-generated ServiceView screens NTX lists in the menu and omnibar.
 *
 * `generateServiceViewRoutes` creates a `<Title> Management` route under
 * `/management/data/<service>` for every service store with
 * `serviceView.enableServiceView`. That is **27 routes** here — Api Services
 * Management, Bom Components Management, Project Phase Items Management, and so
 * on — against roughly fifteen real screens. They dominated the omnibar
 * dropdown and the left menu.
 *
 * Every one of them is also a dead end. `@intrasync/react`'s `ServiceView.Body`
 * resolves the service it should display against the LIBRARY's own
 * `serviceStoresConfig`, which ships as a hardcoded empty array, so
 * `setCurrentService`/`loadServiceData` never run and the grid cannot populate
 * in any host. See docs/quality-control-upstream-issues.md §A.
 *
 * So they are HIDDEN, not removed:
 *   - the routes still exist and are still reachable by name or URL, so nothing
 *     that links to one breaks
 *   - `hidden: true` is the host's existing idiom for exactly this (see
 *     loadHoistOverview.Route, Purchasing.Route)
 *   - the service stores keep `enableServiceView`, so the intent is preserved
 *
 * TO BRING ONE BACK, add its service name below — that is the whole change.
 * When the upstream ServiceView defect is fixed, this list is where the decision
 * about which data screens NTX actually wants gets made.
 */
export const NTX_VISIBLE_SERVICE_VIEWS: readonly string[] = [
  // Intentionally empty. Nothing is worth listing while the screens cannot load.
];

const VISIBLE = new Set(NTX_VISIBLE_SERVICE_VIEWS);

export const isServiceViewVisible = (serviceName: string): boolean =>
  VISIBLE.has(serviceName);
